
<template>
  <!-- 字典管理 -->
  <div chass="app-container">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>字典管理</h5>
              </span>
            </div>
            <div>
              <el-button slot="reference" size="mini" icon="el-icon-circle-plus-outline" @click="adddivshow" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px">添加字典</el-button>
              <el-select v-model="platformTypes" @change="platformTypeschange" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px">
                <el-option label="字典状态" value=""></el-option>
                <el-option label="正常" value="0"></el-option>
                <el-option label="停用" value="1"></el-option>
              </el-select>
              <el-input size="mini" style="width:200px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" v-model="eventNames" placeholder="字典名称模糊查询"></el-input>
              <el-button type="primary" size="mini" @click="mohuchaxun" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" :loading="zidianlodding">查询</el-button>

              <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event,'zidianshuju','字典下载')"></el-button>
              </div>
              <div style="width:100%;float:left" v-loading="zidianlodding">
                <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData1.slice((currentPage1-1)*sizePage1,currentPage1*sizePage1)"
                  class="tb-edit tb-edit1 tb-edit2" style border row-key="id" :tree-props="{children: 'childDTOs'}">
                  <el-table-column prop="dictName" label="字典名称" width="250">
                    <template slot-scope="scope">
                      <span style="color:#646cf5;cursor: pointer;" @click="shijianxiangqing(scope.$index, scope.row)">
                        {{scope.row[scope.column.property]}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" label="字典状态" width="120">
                    <template slot-scope="scope">
                      <!-- {{scope.row[scope.column.property] | statuss}} -->
                      <span v-if="scope.row[scope.column.property] == 1" style='background:#e60039;color:#fff;padding:2px 7px;border-radius:6px'>停用</span>
                      <span v-if="scope.row[scope.column.property] == 0" style='background:#01d053;color:#fff;padding:2px 7px;border-radius:6px'>正常</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isSupportEvent" label="事件绑定" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row[scope.column.property] == 1" style='background:#e60039;color:#fff;padding:2px 7px;border-radius:6px'>否</span>
                      <span v-if="scope.row[scope.column.property] == 0" style='background:#01d053;color:#fff;padding:2px 7px;border-radius:6px'>是</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    <!-- <template slot-scope="scope">
                      <div :title="scope.row[scope.column.property]" style="font-size:12px">
                        {{scope.row[scope.column.property] | eventDescsub}}
                      </div>
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="createTimeDesc" label="创建时间" width="150">
                  </el-table-column>
                  <el-table-column label="操作" width="230">
                    <template slot-scope="scope">
                      <el-button size="mini" style="padding: 4px 15px;" type="success" @click="zidingyishijianupdate(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" style="padding: 4px 15px;" type="danger" v-if="scope.row.mark != 2" @click="zidingyishijiandelete(scope.$index, scope.row)">删除</el-button>
                      <el-button size="mini" style="padding: 4px 15px;float:right;" type="info" @click="zidianxiangqing(scope.$index, scope.row)">详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="padding-bottom:10px">
                  <el-pagination :current-page="currentPage1" :page-sizes="[10,15, 20, 30, 50]" :page-size="sizePage1" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength1"
                    style="margin-top:10px;" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" />
                </div>
                <el-table id="zidianshuju" style="display: none;" :data="tableData1" class="tb-edit tb-edit1" default-expand-all row-key="id" :tree-props="{children: 'childDTOs'}">
                  <el-table-column prop="dictName" label="字典名称" width="250">
                    <template slot-scope="scope">
                      {{scope.row[scope.column.property]}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" label="字典状态" width="120">
                    <template slot-scope="scope">
                      {{scope.row[scope.column.property] | statuss}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="isSupportEvent" label="事件绑定" width="100">
                    <template slot-scope="scope">
                      {{scope.row[scope.column.property] | eventTypes}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注">
                  </el-table-column>
                  <el-table-column prop="createTimeDesc" label="创建时间" width="150">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 字典详情 -->
      <el-dialog :title="zdyshijianxiangqing" :visible.sync="zdydialogTableVisible" width="80%" top="10vh">
        <div>
          <el-button icon="el-icon-circle-plus-outline" size="mini" @click="zijizidianxinzeng" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">新增</el-button>
          <el-button icon="el-icon-upload2" size="mini" @click="zidianishangchuan" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">上传</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="zidiantongbu" v-if="ifSupportSync=='yes'" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">同步</el-button>
        </div>
        <div>
          <el-select v-model="dictDetailTableCondition.status" @change="zidianzijichaxun" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px">
            <el-option label="全部状态" value=""></el-option>
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
          <el-input size="mini" style="width:200px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" v-model="dictDetailTableCondition.dictLabel" placeholder="字典标签模糊查询"></el-input>
          <el-button type="primary" size="mini" @click="zidianzijichaxun" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" :loading="queryDictDataListlodding">查询</el-button>
          <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
            <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="dictDetailDownload"></el-button>
          </div>
          <el-button type="primary" size="mini" @click="piliangshanchu" style="margin-right:15px;float:right;margin-top:10px;margin-bottom:10px" :disabled="this.multipleSelection.length==0">批量删除</el-button>
        </div>
        <div v-loading="queryDictDataListlodding">
          <el-table ref="zidianxiangqingref" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData2" class="tb-edit" style="margin-top:0px" border
            @sort-change="handleAgeSortChange" v-loading="xinagqingloading" @selection-change="handleSelectionChange" :row-key="dictValueKey">
            <el-table-column type="selection" width="55" :reserve-selection="true">
            </el-table-column>
            <el-table-column prop="dictLabel" label="字典标签" sortable='dict_label' min-width="150">
            </el-table-column>
            <el-table-column prop="dictValue" label="字典键值" sortable='dict_value' min-width="150">
            </el-table-column>
            <el-table-column prop="dictSort" label="字典排序" sortable='dict_sort' min-width="120">
            </el-table-column>
            <el-table-column prop="status" label="状态" sortable='status' min-width="100">
              <template slot-scope="scope">
                <!-- {{scope.row[scope.column.property] | statuss}} -->
                <span v-if="scope.row[scope.column.property] == 1" style='background:#e60039;color:#fff;padding:2px 7px;border-radius:6px'>停用</span>
                <span v-if="scope.row[scope.column.property] == 0" style='background:#01d053;color:#fff;padding:2px 7px;border-radius:6px'>正常</span>
              </template>
            </el-table-column>
            <el-table-column prop="dictTypeNameParent" v-if="zidianziji.isSupportParent=='0'" label="父级字典类型" min-width="100">
            </el-table-column>
            <el-table-column prop="dictDataParents" v-if="zidianziji.isSupportParent=='0'" label="父级字典标签" min-width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.dictDataParents.length>0">
                  <span v-for="(item,index) in scope.row.dictDataParents" :key="index+'dictDataParents'">{{item.dictLabel}}<span v-if="index<scope.row.dictDataParents.length-1">,</span></span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" :min-width="zidianziji.isSupportParent=='0'?'120':''">
            </el-table-column>
            <el-table-column prop="dataEmpty" label="操作" width="160">
              <template slot-scope="scope">
                <el-button size="mini" style="padding: 4px 15px;" type="success" @click="zijizidianbianji(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" style="padding: 4px 15px;" type="danger" @click="zijizidianshanchu(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="padding-bottom:10px">
            <el-pagination :current-page="dictDetailTableCondition.pageNo" :page-sizes="[10,15, 20, 30, 50]" :page-size="dictDetailTableCondition.pageSize" layout="->,total,sizes,  prev, pager, next, jumper"
              :pager-count="5" :total="dictDetailTableCondition.total" style="margin-top:10px;" @size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
          </div>
          <el-table id="zidianshujushuxing" style="display: none;" :data="tableData2" class="tb-edit">
            <el-table-column prop="dictLabel" label="字典标签" sortable='custom'>
            </el-table-column>
            <el-table-column prop="dictValue" label="字典键值" sortable='custom'>
            </el-table-column>
            <el-table-column prop="dictSort" label="字典排序" sortable='custom'>
            </el-table-column>
            <el-table-column prop="status" label="状态" sortable='custom'>
              <template slot-scope="scope">
                {{scope.row[scope.column.property] | statuss}}
              </template>
            </el-table-column>
            <el-table-column prop="dictTypeNameParent" v-if="zidianziji.isSupportParent=='0'" label="父级字典类型">
            </el-table-column>
            <el-table-column prop="dictDataParentsname" v-if="zidianziji.isSupportParent=='0'" label="父级字典标签">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <!-- 添加字典信息 -->
      <el-dialog title="添加字典信息" :visible.sync="adddivif" width="1000px" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="字典名称" label-width="80px">
                <el-input v-model="form.dictName" style="width:200px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典状态" label-width="80px">
                <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="事件绑定" label-width="80px">
                <el-switch v-model="form.isSupportEvent" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关">
                </el-switch>
                <div v-if="form.isSupportEvent == 0">
                  <!-- <el-select v-model="queryALLEventsvalue" style="width:119px;" size="mini" @change="queryALLEventschange">
                    <el-option v-for="selectvalue in queryALLEventslist" :key="selectvalue.eventCode" :label="selectvalue.eventName" :value="selectvalue.eventCode"></el-option>
                  </el-select> -->
                  <el-cascader v-model="queryALLEventsvalue" filterable style="width:179px;" size="mini" :options="queryALLEventslist" :props="{ expandTrigger: 'hover' }" @change="queryALLEventschange"></el-cascader>

                  <el-select v-model="queryEventAttrsByEventCodevalue" style="width:149px;" size="mini" filterable>
                    <el-option v-for="selectvalue in queryEventAttrsByEventCodelist" :key="selectvalue.value" :label="selectvalue.value+'（'+selectvalue.label+'）'" :value="selectvalue.value"></el-option>
                  </el-select>
                  <el-button style="" type="primary" @click="addshijianbangding" size="mini">添加</el-button>
                  <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="sjtableData5" class="tb-edit tb-edit1" border style="width:400px">
                    <el-table-column prop="sourceName" label="来源" width="100px">
                    </el-table-column>
                    <el-table-column prop="eventName" label="事件名" width="114px">
                    </el-table-column>
                    <el-table-column prop="eventAttrName" label="事件属性" width="113px">
                    </el-table-column>
                    <el-table-column label="操作" width="72px">
                      <template slot-scope="scope">
                        <el-button size="mini" style="padding: 4px 15px;" type="danger" @click="deletesjtableData5(scope.$index, scope.row)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="父级绑定" label-width="80px">
                <el-switch v-model="form.isSupportParent" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关">
                </el-switch>
                <div v-if="form.isSupportParent == 0">
                  <el-select v-model="form.dictTypeParent" size="mini">
                    <el-option v-for="selectvalue in queryParentlist" :key="selectvalue.dictType" :label="selectvalue.dictName" :value="selectvalue.dictType"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" label-width="80px">
                <el-input v-model="form.remark" type="textarea" style="width:700px"></el-input>
              </el-form-item>
              <el-form-item style="margin-top:30px;">
                <el-button style="margin-left:80px;" type="primary" :loading="loading1" @click="onSubmit">立即创建</el-button>
                <el-button @click="hidedivshow">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑字典信息 -->
      <el-dialog title="编辑字典信息" :visible.sync="updatedivif" width="1000px" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="uform">
          <el-row>
            <el-col :span="12">
              <el-form-item label="字典名称" label-width="80px">
                <el-input v-model="uform.dictName" style="width:200px" :disabled="xitongmark=='2'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典状态" label-width="80px">
                <el-switch v-model="uform.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关" :disabled="xitongmark=='2'">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="事件绑定" label-width="80px">
                <el-switch v-model="uform.isSupportEvent" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关" :disabled="xitongmark=='2'">
                </el-switch>
                <div v-if="uform.isSupportEvent == 0">
                  <!-- <el-select v-model="queryALLEventsvalue" style="width:119px;" size="mini" @change="queryALLEventschange">
                    <el-option v-for="selectvalue in queryALLEventslist" :key="selectvalue.eventCode" :label="selectvalue.eventName" :value="selectvalue.eventCode"></el-option>
                  </el-select> -->
                  <el-cascader v-model="queryALLEventsvalue" filterable style="width:179px;" size="mini" :options="queryALLEventslist" :props="{ expandTrigger: 'hover' }" @change="queryALLEventschange"></el-cascader>

                  <el-select v-model="queryEventAttrsByEventCodevalue" style="width:149px;" size="mini" filterable>
                    <el-option v-for="selectvalue in queryEventAttrsByEventCodelist" :key="selectvalue.value" :label="selectvalue.value+'（'+selectvalue.label+'）'" :value="selectvalue.value"></el-option>
                  </el-select>
                  <el-button style="" type="primary" @click="addshijianbangding" size="mini">添加</el-button>
                  <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="sjtableData5" class="tb-edit tb-edit1" border style="width:400px">
                    <el-table-column prop="sourceName" label="来源" width="100px">
                    </el-table-column>
                    <el-table-column prop="eventName" label="事件名" width="114px">
                    </el-table-column>
                    <el-table-column prop="eventAttrName" label="事件属性" width="113px">
                    </el-table-column>
                    <el-table-column label="操作" width="72px">
                      <template slot-scope="scope">
                        <el-button size="mini" style="padding: 4px 15px;" type="danger" v-if="scope.row.mark != 2" @click="deletesjtableData5(scope.$index, scope.row)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="父级绑定" label-width="80px">
                <el-switch v-model="uform.isSupportParent" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关" :disabled="xitongmark=='2'">
                </el-switch>
                <div v-if="uform.isSupportParent == 0">
                  <el-select v-model="uform.dictTypeParent" size="mini">
                    <el-option v-for="selectvalue in queryParentlist" :key="selectvalue.dictType" :label="selectvalue.dictName" :value="selectvalue.dictType"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" label-width="80px">
                <el-input v-model="uform.remark" type="textarea" style="width:700px" :disabled="xitongmark=='2'"></el-input>
              </el-form-item>
              <el-form-item style="margin-top:30px;">
                <el-button style="margin-left:80px;" type="primary" :loading="loading1" @click="onSubmituform">保存修改</el-button>
                <el-button @click="hidedivshowuform">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 事件详情 -->
      <el-dialog title="字典信息详情" :visible.sync="infoshow" width="1000px">
        <el-form ref="form" :inline="true" :model="zidianinfo">
          <el-row>
            <el-col :span="12">
              <el-form-item label="字典名称" label-width="80px">
                <el-input v-model="zidianinfo.dictName" style="width:200px" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典状态" label-width="80px">
                <el-switch v-model="zidianinfo.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关" disabled>
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="事件绑定" label-width="80px">
                <el-switch v-model="zidianinfo.isSupportEvent" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关" disabled>
                </el-switch>
                <div v-if="zidianinfo.events.length > 0">
                  <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="zidianinfo.events" class="tb-edit tb-edit1" border style="width:400px">
                    <el-table-column prop="sourceName" label="来源">
                    </el-table-column>
                    <el-table-column prop="eventName" label="事件名">
                    </el-table-column>
                    <el-table-column prop="eventAttrName" label="事件属性">
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="父级绑定" label-width="80px">
                <el-switch v-model="zidianinfo.isSupportParent" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="开" inactive-text="关" disabled>
                </el-switch>
                <div v-if="zidianinfo.dictTypeParentName != ''">
                  <el-input v-model="zidianinfo.dictTypeParentName" style="width:200px" disabled></el-input>
                </div>
              </el-form-item>

            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="事件描述" label-width="80px">
                <el-input v-model="zidianinfo.remark" type="textarea" style="width:500px" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>

      <!-- 添加详情信息 -->
      <el-dialog title="字典数据维护" :visible.sync="ziformadddivif" width="800px" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="ziform">
          <el-row>
            <el-col :span="12">
              <el-form-item label="字典标签" label-width="120px">
                <el-input v-model="ziform.dictLabel" style="width:250px" placeholder="不超过100个字符"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典键值" label-width="120px">
                <el-input v-model="ziform.dictValue" style="width:250px" placeholder="不超过100个字符"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="数据状态" label-width="120px">
                <el-switch v-model="ziform.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="正常" inactive-text="停用">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典排序" label-width="120px">
                <el-input v-model="ziform.dictSort" style="width:250px" placeholder="整数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="zidianziji.isSupportParent=='0'">
            <el-col :span="12">
              <el-form-item label="父级字典名称" label-width="120px">
                <el-input v-model="dictTypeParentnameziform" style="width:250px" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="父级字典标签" label-width="120px">
                <el-select v-model="dictValueParentsvalue" multiple collapse-tags clearable class="selectduoxuan" style="width:250px">
                  <el-option v-for="selectvalue in dictDataParentslist" :key="selectvalue.dictValue" :label="selectvalue.dictLabel" :value="selectvalue.dictValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" label-width="120px">
                <el-input v-model="ziform.remark" type="textarea" style="width:645px"></el-input>
              </el-form-item>
              <el-form-item style="margin-top:30px;">
                <el-button style="margin-left:80px;" type="primary" :loading="loading2" @click="ziformonSubmit">立即创建</el-button>
                <el-button @click="ziformhidedivshow">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑字典详情信息 -->
      <el-dialog title="编辑字典信息" :visible.sync="ziformupdatedivif" width="800px" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="ziuform">
          <el-row>
            <el-col :span="12">
              <el-form-item label="字典标签" label-width="120px">
                <el-input v-model="ziuform.dictLabel" style="width:250px" placeholder="不超过100个字符"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典键值" label-width="120px">
                <el-input v-model="ziuform.dictValue" style="width:250px" placeholder="不超过100个字符"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="数据状态" label-width="120px">
                <el-switch v-model="ziuform.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="'0'" :inactive-value="'1'" active-text="正常" inactive-text="停用">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典排序" label-width="120px">
                <el-input v-model="ziuform.dictSort" style="width:250px" placeholder="整数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="zidianziji.isSupportParent=='0'">
            <el-col :span="12">
              <el-form-item label="父级字典名称" label-width="120px">
                <el-input v-model="ziuform.dictTypeNameParent" style="width:250px" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="父级字典标签" label-width="120px">
                <el-select v-model="dictValueParentsvalueup" multiple collapse-tags clearable class="selectduoxuan" style="width:250px">
                  <el-option v-for="selectvalue in dictDataParentslist" :key="selectvalue.dictValue" :label="selectvalue.dictLabel" :value="selectvalue.dictValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" label-width="120px">
                <el-input v-model="ziuform.remark" type="textarea" style="width:645px"></el-input>
              </el-form-item>
              <el-form-item style="margin-top:30px;">
                <el-button style="margin-left:80px;" type="primary" :loading="loading2" @click="ziuformonSubmit">保存修改</el-button>
                <el-button @click="hidedivshowziuform">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>

      <el-dialog title="上传文件" :visible.sync="dialogFormVisibleupload" width="620px" :close-on-click-modal="false">
        <el-form :model="form">
          <el-form-item label="选择文件" label-width="120px">
            <el-upload class="upload-demo" action="https://gateway.yingxiong.com/bdc4-gateway/api/dictData/importData" :limit="1" :auto-upload="false" :on-preview="handlePreview" :on-remove="handleRemove"
              :on-change="handleChange" :before-remove="beforeRemove" :file-list="fileList" accept=".xls;*.xlsx;">
              <el-button size="small" type="primary">选择文件</el-button>
              <div class="el-upload__tip" slot="tip">
                <span style="color:#666;line-height: 20px;">仅允许导入“xls”或“xlsx”格式文件</span><br>
                <span v-if="ifSupportParent=='yes'" style="color:#ff0000;line-height: 20px;">
                  <div>注：</div>
                  <div>1.文件中第一行为数据，没有标题！</div>
                  <div>2.Excel文件的格式为四列：字典键值code，字典标签name，备注，父级字典键值code</div>
                  <div>3.当字典键值code存在，则更新，不存在则会插入创建</div>
                  <!-- <div>3.当字典键值code存在，但字典标签name不同时，不会更新，会插入创建（标签去重规则：根据 字典键值+字典标签 组合去重）</div> -->
                </span>
                <span v-if="ifSupportParent=='no'" style="color:#ff0000;line-height: 20px;">
                  <div>注:</div>
                  <div>1.文件中第一行为数据，没有标题！</div>
                  <div>2.Excel文件的格式为三列：字典键值code，字典标签name，备注</div>
                  <div>3.当字典键值code存在，则更新，不存在则会插入创建</div>
                  <!-- <div>3.当字典键值code存在，但字典标签name不同时，不会更新，会插入创建（标签去重规则：根据 字典键值+字典标签 组合去重）</div> -->
                </span>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisibleupload = false">取 消</el-button>
          <el-button type="primary" :loading="uploadloading" @click="uploadfilesubmit">上 传</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {
  queryDictTypeList,
  queryDictTypeById,
  queryParent,
  queryALLEvents,
  queryEventAttrsByEventCode,
  createDictType,
  updateDictType,
  deleteDictTypeById,
  queryDictDataList,
  downloadDictDetail,
  createDictData,
  updateDictData,
  deleteDictDataById,
  synData,
  queryDictDataParentList,
  uploadData
} from "@Bdc~/api/ajax_model";

import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "",
  components: {},
  data() {
    return {
      loading2: false,
      loading1: false,
      dictDetailTableCondition: {
        dictType: '',
        status: '',
        dictLabel: '',
        pageNo: 1,
        pageSize: 10,
        orderByColumn: '',//排序字段
        isAsc: 'desc',    //排序方式
        total: 0,
      },
      form: {
        appkey: this.$store.getters.appkey,
        dictName: "",
        isSupportEvent: "1",
        isSupportParent: "1",
        status: "1",
        remark: "",
        dictTypeParent: "",
        sasDictTypeEventList: []
      },
      uform: {
        id: "",
        appkey: "",
        dictType: " ",
        dictName: "",
        isSupportEvent: "1",
        isSupportParent: "1",
        status: "1",
        remark: "",
        dictTypeParent: "",
        sasDictTypeEventList: []
      },
      zidianinfo: {
        id: "",
        dictType: "",
        dictTypeParent: "",
        appkey: "",
        dictName: "",
        isSupportEvent: "",
        isSupportParent: "",
        status: "",
        mark: "",
        remark: "",
        createTimeDesc: "",
        events: [],
        childDTOs: []
      },
      dictValueParentsvalue: "",
      dictTypeParentnameziform: "",
      ziform: {
        appkey: this.$store.getters.appkey,
        dictType: "",
        dictLabel: "",
        dictValue: "",
        dictSort: "",
        status: "0",
        remark: "",
        dictTypeParent: "",
        dictValueParents: ""
      },
      dictValueParentsvalueup: "",
      ziuform: {
        id: "",
        appkey: "",
        dictType: "",
        dictLabel: "",
        dictValue: "",
        dictSort: "",
        status: "0",
        remark: "",
        dictTypeParent: "",
        dictValueParents: ""
      },
      adddivif: false,
      updatedivif: false,
      infoshow: false,
      dialogFormVisibleupload: false,
      uploadloading: false,

      fileList: [],

      platformTypes: "",
      eventNames: "",
      eventshowid: "",
      dictTypes: "",
      queryParentlist: [],

      queryALLEventslist: [],
      queryEventAttrsByEventCodelist: [],
      queryALLEventscode: "",
      queryALLEventssource: "",
      queryALLEventsvalue: "",
      queryEventAttrsByEventCodevalue: "",

      zdydialogTableVisible: false,
      zdyshijianxiangqing: "",

      tableData1: [],
      currentPage1: 1,
      dataLength1: 1,
      sizePage1: 10,

      tableData2: [],
      tableData2copy: [],
      sizePage2: 10,

      sjtableData5: [],
      sjcurrentPage5: 1,
      sjdataLength5: 1,
      sjsizePage5: 10,
      zidianlodding: false,
      queryDictDataListlodding: false,
      zidianziji: {
        dictTypeParent: "",
        dictTypeNameParent: "",
        dictType: "",
        status: "",
        dictLabel: "",
        isSupportParent: ""
      },
      ifSupportSync: "yes",
      ifSupportParent: "yes",
      dictDataParentslist: [],
      ziformadddivif: false,
      ziformupdatedivif: false,
      xinagqingloading: false,
      xitongmark: 1,
      multipleSelection: []
    };
  },
  created() {
    this.queryDictTypeList();
  },
  mounted() { },

  watch: {
    zdydialogTableVisible(val) {
      this.dictDetailTableCondition.status = ''
      this.dictDetailTableCondition.dictLabel = ''
      this.dictDetailTableCondition.orderByColumn = ''
      this.dictDetailTableCondition.dictLabel = ''
    },
  },

  methods: {
    queryDictTypeList() {
      this.zidianlodding = true;
      queryDictTypeList(
        this.eventNames,
        this.platformTypes
      ).then(response => {
        console.log(response);
        this.zidianlodding = false;
        if (response.code == 1) {
          this.tableData1 = response.data;
          this.dataLength1 = response.data.length;

          if (this.tableData1.slice((this.currentPage1 - 1) * this.sizePage1, this.currentPage1 * this.sizePage1).length == 0) {
            this.currentPage1 = 1
          }
        }
      });
    },
    queryDictDataParentList() {
      console.log(this.zidianziji.dictType);
      queryDictDataParentList(
        this.zidianziji.dictType
      ).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.dictDataParentslist = response.data;
        }
      });
    },
    queryDictTypeById() {
      queryDictTypeById(this.eventshowid).then(
        response => {
          console.log(response);
          if (response.code == 1) {
            this.zidianinfo = response.data;
          }
        }
      );
    },
    synData() {
      this.xinagqingloading = true;

      synData(this.zidianziji.dictType).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: response.data,
            type: "success"
          });
          this.queryDictDataList();
        } else {
          this.$message.warning(response.msg);
        }
      });
    },
    queryDictTypeByIdlist() {
      queryDictTypeById(this.eventshowid).then(
        response => {
          console.log("queryDictTypeById", response.data);
          if (response.code == 1) {
            this.dictDetailTableCondition.dictType = response.data.dictType
            this.dictDetailTableCondition.pageNo = 1
            this.dictDetailTableCondition.pageSize = 10

            this.zidianziji.dictType = response.data.dictType;
            this.zidianziji.dictName = response.data.dictName;
            this.zidianziji.dictTypeParent = response.data.dictTypeParent;
            this.zidianziji.dictTypeParentName =
              response.data.dictTypeParentName;
            this.zidianziji.isSupportParent =
              response.data.isSupportParent;
            this.dictTypeParentnameziform =
              response.data.dictTypeParentName;

            this.zdydialogTableVisible = true;

            this.$nextTick(() => {
              this.multipleSelection = [];
              this.$refs.zidianxiangqingref.clearSelection()
            })

            this.queryDictDataList();
            if (this.zidianziji.isSupportParent == '0') {
              // 字典为子集的时候再去请求相关的父级字典标签下拉数据
              this.queryDictDataParentList();
            }
          }
        }
      );
    },
    queryDictTypeByIdupdate() {
      queryDictTypeById(this.eventshowid).then(
        response => {
          console.log(response);
          if (response.code == 1) {
            this.uform = response.data;
            this.sjtableData5 = response.data.events;
          }
        }
      );
    },
    queryParent() {
      queryParent(this.dictTypes).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.queryParentlist = response.data;
        }
      });
    },
    queryALLEvents() {
      queryALLEvents().then(response => {
        console.log("queryALLEventslist", response);
        if (response.code == 1) {
          this.queryALLEventslist = response.data;
        }
      });
    },
    queryEventAttrsByEventCode() {
      queryEventAttrsByEventCode(
        this.queryALLEventscode,
        this.queryALLEventssource

      ).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.queryEventAttrsByEventCodelist = response.data;
        }
      });
    },
    queryDictDataList() {
      this.queryDictDataListlodding = true;
      queryDictDataList(
        this.dictDetailTableCondition
      ).then(response => {

        this.queryDictDataListlodding = false;
        if (response.code == 1) {
          for (var i = 0; i < response.data.length; i++) {
            var dictDataParentsname = "";
            for (
              var j = 0;
              j < response.data[i].dictDataParents.length;
              j++
            ) {
              dictDataParentsname +=
                response.data[i].dictDataParents[j].dictLabel + "，";
            }
            dictDataParentsname = dictDataParentsname.substring(
              0,
              dictDataParentsname.length - 1
            );
            response.data[i].dictDataParentsname = dictDataParentsname;
          }
          this.tableData2 = response.data.result;
          // this.tableData2copy = JSON.parse(JSON.stringify(response.data));


          this.dictDetailTableCondition.total = response.data.totalCount


          this.ifSupportSync = response.extra.ifSupportSync;
          this.ifSupportParent = response.extra.ifSupportParent;

          // if (this.tableData2.slice((this.currentPage2 - 1) * this.sizePage2, this.currentPage2 * this.sizePage2).length == 0) {
          //   this.currentPage2 = 1
          // }
        }
        this.xinagqingloading = false;
      });
    },

    queryALLEventschange(e) {
      console.log(e);
      this.queryALLEventssource = e[0];
      this.queryALLEventscode = e[1];
      this.queryEventAttrsByEventCodevalue = "";
      this.queryEventAttrsByEventCode();
    },
    shijianxiangqing(index, row) {
      //查看自定义事件详情
      this.eventshowid = row.id;
      this.queryDictTypeByIdlist();
    },
    zidianxiangqing(index, row) {
      //查看自定义事件详情
      this.infoshow = true;
      this.eventshowid = row.id;
      this.queryDictTypeById();
    },
    zidingyishijianupdate(index, row) {
      this.xitongmark = row.mark;

      this.dictTypes = row.dictType
      this.updatedivif = true;
      this.eventshowid = row.id;
      this.sjtableData5 = [];
      this.queryALLEventslist = [];
      this.queryEventAttrsByEventCodelist = [];
      this.queryALLEventsvalue = "";
      this.queryEventAttrsByEventCodevalue = "";
      this.queryParent();
      this.queryALLEvents();
      this.queryDictTypeByIdupdate();
    },

    zidingyishijiandelete(index, row) {
      // 字典删除
      this.$confirm('确认删除 "' + row.dictName + '" 吗？')
        .then(_ => {
          deleteDictTypeById(row.id).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.queryDictTypeList();
            }
          });
        })
        .catch(_ => { });
    },
    mohuchaxun() {
      this.queryDictTypeList();
    },
    platformTypeschange() {
      this.queryDictTypeList();
    },
    onSubmit() {
      // 添加字典
      var listarr = [];
      for (var i = 0; i < this.sjtableData5.length; i++) {
        listarr.push({
          eventCode: this.sjtableData5[i].eventCode,
          eventAttr: this.sjtableData5[i].eventAttr,
          source: this.sjtableData5[i].source
        });
      }
      this.form.sasDictTypeEventList = listarr;
      console.log(this.form);
      this.loading1 = true;
      createDictType(this.form).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.queryDictTypeList();
          this.adddivif = false;
        }
        this.loading1 = false;
      });
    },
    onSubmituform() {
      // 修改字典
      var listarr = [];
      for (var i = 0; i < this.sjtableData5.length; i++) {
        listarr.push({
          eventCode: this.sjtableData5[i].eventCode,
          eventAttr: this.sjtableData5[i].eventAttr,
          source: this.sjtableData5[i].source
        });
      }
      this.uform.sasDictTypeEventList = listarr;
      delete this.uform.events;
      delete this.uform.childDTOs;
      delete this.uform.createTimeDesc;
      delete this.uform.mark;
      delete this.uform.dictTypeParentName;
      console.log(this.uform);
      this.loading1 = true;
      updateDictType(this.uform).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.queryDictTypeList();
          this.updatedivif = false;
        }
        this.loading1 = false;
      });
    },
    adddivshow() {
      this.dictTypes = "";
      this.adddivif = true;
      this.form = {
        appkey: this.$store.getters.appkey,
        dictName: "",
        isSupportEvent: "1",
        isSupportParent: "1",
        status: "1",
        remark: "",
        dictTypeParent: "",
        sasDictTypeEventList: []
      };
      this.sjtableData5 = [];
      this.queryALLEventslist = [];
      this.queryEventAttrsByEventCodelist = [];
      this.queryALLEventsvalue = "";
      this.queryEventAttrsByEventCodevalue = "";

      this.queryParent();
      this.queryALLEvents();
    },
    hidedivshow() {
      this.adddivif = false;
    },
    hidedivshowuform() {
      this.updatedivif = false;
    },
    handleSizeChange1(e) {
      // table 分页数量变化
      this.sizePage1 = e;
    },
    handleCurrentChange1(e) {
      // table 分页变化
      this.currentPage1 = e;
    },
    handleSizeChange2(e) {
      // table 分页数量变化
      this.dictDetailTableCondition.pageSize = e
      this.sizePage2 = e;
      this.multipleSelection = [];
      this.$refs.zidianxiangqingref.clearSelection()
      this.queryDictDataList()
      console.log('字典详情展示条数变化', this.dictDetailTableCondition)
    },
    handleCurrentChange2(e) {
      // table 分页变化
      this.dictDetailTableCondition.pageNo = e
      this.multipleSelection = [];
      this.$refs.zidianxiangqingref.clearSelection()
      this.queryDictDataList()
      console.log('dictDetailTableCondition', this.dictDetailTableCondition)
    },
    // 字典详情下载
    dictDetailDownload() {
      console.log('字典详情下载')
      let param = {
        status: this.dictDetailTableCondition.status,
        dictType: this.dictDetailTableCondition.dictType,
        dictLabel: this.dictDetailTableCondition.dictLabel,
      }
      downloadDictDetail(param)
    },
    exportExcel(e, id, name) {
      console.log('', e)
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector("#" + id));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    addshijianbangding() {
      console.log(this.queryALLEventsvalue);
      if (this.queryALLEventsvalue[0] == "" || this.queryALLEventsvalue[1] == "" || this.queryEventAttrsByEventCodevalue == "") {
        this.$message.warning("请选择完整事件属性");
        return false
      }

      var arr = []
      var str = this.queryALLEventsvalue[0] + "_" + this.queryALLEventsvalue[1] + "_" + this.queryEventAttrsByEventCodevalue
      for (var i = 0; i < this.sjtableData5.length; i++) {
        arr.push(this.sjtableData5[i].source + "_" + this.sjtableData5[i].eventCode + "_" + this.sjtableData5[i].eventAttr)
      }
      if (arr.indexOf(str) > -1) {
        this.$message.warning("不可重复添加同一属性");
        return false
      }

      var obj = {};
      for (var i = 0; i < this.queryALLEventslist.length; i++) {
        if (this.queryALLEventslist[i].value == this.queryALLEventsvalue[0]) {
          for (var j = 0; j < this.queryALLEventslist[i].children.length; j++) {
            if (this.queryALLEventslist[i].children[j].value == this.queryALLEventsvalue[1]) {
              obj["eventCode"] = this.queryALLEventslist[i].children[j].value;
              obj["eventName"] = this.queryALLEventslist[i].children[j].label;
              obj["source"] = this.queryALLEventslist[i].value;
              obj["sourceName"] = this.queryALLEventslist[i].label;
            }
          }
        }
      }
      for (var i = 0; i < this.queryEventAttrsByEventCodelist.length; i++) {
        if (
          this.queryEventAttrsByEventCodelist[i].value ==
          this.queryEventAttrsByEventCodevalue
        ) {
          obj["eventAttr"] = this.queryEventAttrsByEventCodelist[i].value;
          obj["eventAttrName"] = this.queryEventAttrsByEventCodelist[
            i
          ].label;
        }
      }
      console.log(obj);
      this.sjtableData5.push(obj);
    },
    deletesjtableData5(index, row) {
      console.log(index);
      this.sjtableData5.splice(index, 1);
    },
    zidianzijichaxun() {
      this.dictDetailTableCondition.pageNo = 1
      this.queryDictDataList();
    },
    zijizidianxinzeng() {
      this.dictValueParentsvalue = "";
      this.ziform = {
        appkey: this.$store.getters.appkey,
        dictType: this.zidianziji.dictType,
        dictLabel: "",
        dictValue: "",
        dictSort: "",
        status: "0",
        remark: "",
        dictTypeParent: this.zidianziji.dictTypeParent,
        dictValueParents: ""
      };
      this.ziformadddivif = true;
    },
    ziformhidedivshow() {
      this.ziformadddivif = false;
    },
    zidianishangchuan() {
      this.fileList = [];
      this.dialogFormVisibleupload = true;
    },
    uploadfilesubmit() {

      if (this.fileList.length < 1) {
        this.$message.warning("请选择上传文件")
        return false
      }
      var fd = new FormData();
      fd.append("appkey", this.$store.getters.appkey);
      fd.append("dictType", this.zidianziji.dictType);

      var types = ["xls", "xlsx"]

      for (var i = 0; i < this.fileList.length; i++) {
        var f = this.fileList[i].name.split(".");
        var s = f[f.length - 1]
        if (types.indexOf(s.toLowerCase()) == -1) {
          this.$message.warning("所选文件 " + this.fileList[i].name + " 格式不符");
          return false
        }
      }

      for (var i = 0; i < this.fileList.length; i++) {
        fd.append("file", this.fileList[i].raw);
      }

      this.uploadloading = true;
      uploadData(fd).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message.success(response.data);
          this.queryDictDataList();
          this.uploadloading = false;
          this.dialogFormVisibleupload = false;
        }
      });

    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file, fileList) {
      this.$confirm(`确定移除 ${file.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileList = fileList;
      }).catch(() => {
        console.log("cancel");
      });
    },


    zidiantongbu() {
      this.dictDetailTableCondition.pageNo = 1
      this.synData();
    },
    ziformonSubmit() {
      // if (this.zidianziji.isSupportParent == "0") {
      //   if (this.dictValueParentsvalue.length == 0) {
      //     this.$message.warning("请选择父级字典标签")
      //     return false
      //   }
      // }
      // 添加字典
      this.ziform.dictValueParents = "";
      for (var i = 0; i < this.dictValueParentsvalue.length; i++) {
        this.ziform.dictValueParents += this.dictValueParentsvalue[i] + ",";
      }
      this.ziform.dictValueParents = this.ziform.dictValueParents.substring(
        0,
        this.ziform.dictValueParents.length - 1
      );
      console.log(this.ziform);
      this.loading2 = true;
      createDictData(this.ziform).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.queryDictDataList();
          this.ziformadddivif = false;
        }
        this.loading2 = false;
      });
    },
    zijizidianbianji(index, row) {
      this.ziformupdatedivif = true;
      this.ziuform = row;
      this.dictValueParentsvalueup = [];
      for (var i = 0; i < this.ziuform.dictDataParents.length; i++) {
        this.dictValueParentsvalueup.push(
          this.ziuform.dictDataParents[i].dictValue
        );
      }
      console.log(this.ziuform);
    },
    ziuformonSubmit() {
      this.ziuform.dictValueParents = "";
      for (var i = 0; i < this.dictValueParentsvalueup.length; i++) {
        this.ziuform.dictValueParents += this.dictValueParentsvalueup[i] + ",";
      }
      this.ziuform.dictValueParents = this.ziuform.dictValueParents.substring(
        0,
        this.ziuform.dictValueParents.length - 1
      );
      delete this.ziuform.dictDataParents;
      delete this.ziuform.dictDataParentsname;
      delete this.ziuform.dictTypeNameParent;
      console.log(this.ziuform);
      this.loading2 = true;
      updateDictData(this.ziuform).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.queryDictDataList();
          this.ziformupdatedivif = false;
        }
        this.loading2 = false;
      });
    },
    hidedivshowziuform() {
      this.ziformupdatedivif = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    dictValueKey(row) {
      // console.log(row)
      return row.id
    },
    zijizidianshanchu(index, row) {
      this.$confirm('确认删除 "' + row.dictLabel + '" 吗？')
        .then(_ => {
          deleteDictDataById(row.id).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.multipleSelection = [];
              this.$refs.zidianxiangqingref.clearSelection()
              this.queryDictDataList();
            }
          });
        })
        .catch(_ => { });
    },
    piliangshanchu() {
      var ids = [];
      this.multipleSelection.forEach(item => {
        ids.push(item.id)
      })
      ids = String(ids)
      this.$confirm('确认删除所选字典标签吗？')
        .then(_ => {
          deleteDictDataById(ids).then(response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.multipleSelection = [];
              this.$refs.zidianxiangqingref.clearSelection()
              this.queryDictDataList();

            }
          });
        })
        .catch(_ => { });
    },
    handleAgeSortChange(e) {
      console.log('字典详情排序')
      console.log(e);
      this.dictDetailTableCondition.pageNo = 1
      this.dictDetailTableCondition.isAsc = e.order == "ascending" ? 'ASC' : 'DESC'
      this.dictDetailTableCondition.orderByColumn = e.column.sortable
      console.log(this.dictDetailTableCondition)
      this.queryDictDataList()
    },
  },
  filters: {
    statuss(value) {
      if (value == "0") {
        return "正常";
      } else if (value == "1") {
        return "停用";
      }
    },
    eventTypes(value) {
      if (value == "0") {
        return "是";
      } else if (value == "1") {
        return "否";
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + "...";
      } else {
        return value;
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
::v-deep .el-table__body .el-table-column--selection .cell {
  padding-left: 16px !important;
  padding-right: 0px !important;
}
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.tb-edit2 tr td {
  padding: 0px 0px;
  height: 40px;
  line-height: 40px;
}

.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
.el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}
.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
.selectduoxuan .el-select__tags .el-tag {
  display: inline-block;
  max-width: 65%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
